<template>
  <div class="page-content">
    <form
      method="post"
      id="upay_form"
      name="upay_form"
      action="https://fidelitypaygate.fidelitybank.ng/cipg/MerchantServices/MakePayment.aspx"
      target="_top"
    >
      <input type="hidden" name="mercId" :value="mrchId">
      <input type="hidden" name="currCode" value="566">
      <input type="hidden" name="amt" value="1.00">
      <input type="hidden" name="orderId" :value="generateTx()">
      <input type="hidden" name="prod" :value="paymentFormSelected">
      <input type="hidden" name="email" :value="getUserSession.email">
      <input type="hidden" name="phone" :value="getUserSession.phoneNumber">
      <input type="hidden" name="hash" :value="generateTx()">
      <input name="submit" type="submit" ref="upay_form" style="display: none;">
    </form>

    <b-modal centered id="paymentModal" ref="paymentModal" hide-footer>
      <div slot="modal-header" style="text-align: center !important;">
        <b-btn
          class="close custom-modal__close"
          style="justify-content: center
          !important; font-size: .89em;"
          @click="hideModal"
        >
          <span aria-hidden="true" class="fa fa-close"></span>
        </b-btn>
        <h1 class="page-content__header-description">Payment Method</h1>
      </div>
      <div class="d-block text-center">
        <b-button variant="link" class="payment_options" block to="/shs/pay">
          <img src="/static/img/rave.jpg" alt>
        </b-button>
        <b-button variant="link" class="payment_options" @click="triggerPaygate">
          <img src="/static/img/paygate.png" height="80" alt>
        </b-button>
      </div>
    </b-modal>

    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div
            class="page-content__header-description"
            style="display: flex;padding: 20px !important;"
          >
            <h2 style="flex: 1;">Payments</h2>
          </div>
          <!-- <div class="container"> -->
          <el-tabs v-model="activeTab">
            <can I="create" a="wallet">
              <el-tab-pane label="Fund Wallet" name="fundwallet">
                <FundWallet></FundWallet>
              </el-tab-pane>
            </can>
            <can I="create" a="token">
              <el-tab-pane label="Renew Subscription Plan" name="renewsub">
                <div class="widget widget-alpha">
                  Renew your devices or for someone else's device's subscription plan.
                  <router-link class="btn" :to="{name:'GenerateToken'}">
                    <!-- <b-button variant="info">Renew Subscription</b-button> -->
                  </router-link>
                </div>
              </el-tab-pane>
            </can>
            <can I="read" a="token">
              <can I="read" a="wallet">
                <el-tab-pane label="Transaction History" name="transactions">
                  <transaction-histories/>
                </el-tab-pane>
              </can>
            </can>
          </el-tabs>
          <!-- </div> -->
        </div>
        <!-- <div class="col-lg-3 col-md-3">
          <RightBar></RightBar>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import FundWallet from "../shs/ravepay";
import RightBar from "../rightBar";
import transactionHistories from "../shs/Wallet";
export default {
  name: "",
  components: {
    FundWallet,
    RightBar,
    transactionHistories
  },
  data() {
    return {
      activeTab: "fundwallet",
      txId: "",
      mrchId: "09554",
      responseData: "",
      errors: "",
      componentName: "",
      columns: [
        {
          label: "Transaction Amount",
          field: "actualAmount",
          filterable: true
        },
        {
          label: "Status",
          field: "status",
          filterable: true
        },
        {
          label: "Transaction Type",
          field: "transactionType",
          filterable: true
        },
        {
          label: "Date",
          field: "createdAt",
          filterable: true
        }
      ],
      rows: [
        // { user: "300283377", ref: "2012020321", date: "12/12/2015" },
        // { user: "305383177", ref: "2012020321", date: "12/01/1991" }
      ]
    };
  },
  methods: {
    triggerPaygate() {
      this.$refs.upay_form.click();
    },
    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.paymentModal.show();
    },
    hideModal() {
      this.$refs.paymentModal.hide();
    },
    hashCode(str) {
      str = str + "";
      return str;
      // .split("")
      // .reduce(
      //   (prevHash, currVal) =>
      //     ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
      //   0
      // );
    },
    generateTx() {
      // console.log(this.getUserSession);
      return this.hashCode(Date.now() * this.getUserSession.id + "");
    },
    getHistory() {
      const HTTP = this.$httpUtils.instance;
      let url = `/transactionHistories?filter[where][userId]=${
        this.getUserSession.id
      }`;
      if (this.$can("read", "all")) {
        url = `/transactionHistories`;
      }

      const container = this;
      HTTP.get(url)
        .then(response => {
          // container.$router.push({path: `/device/${response.data.data.inverter_number}`});
          container.rows = response.data;
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  mounted() {
    if (!this.$can("read", "wallet")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    this.generateTx();
    this.getHistory();
    // console.log(this.getUserSession.id);
  }
};
</script>

<style lang="scss">
.custom-radio .custom-control-indicator {
  // display: none !important;
  border: none !important;
}

.custom-radio .custom-control-description {
  padding-left: 15px;
}

.container .widget-icon {
  margin-top: 0 !important;
  display: none;
}

.page-content {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/payments.vue